<template>
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 77.6667C20 66.0687 29.402 56.6667 41 56.6667C52.598 56.6667 62 66.0687 62 77.6667H20Z"
      fill="#FFD9C3"
    />
    <path
      d="M56.6667 57.6667L70.6667 50.6667L85.0001 57.6667V62.6667L83.0001 74L77.0001 83.3333L70.6667 86.3333L65.0001 83.3333L58.0001 75.6667L56.6667 68.3333V57.6667Z"
      fill="#55ACEE"
    />
    <path
      d="M40.7194 46.8619C50.1621 46.8619 57.817 39.2074 57.817 29.7643C57.817 20.3216 50.1621 12.6667 40.7194 12.6667C31.2768 12.6667 23.6218 20.3216 23.6218 29.7643C23.6309 39.2039 31.2803 46.8528 40.7194 46.8619ZM40.7194 15.9017C48.3759 15.9017 54.582 22.1088 54.582 29.7643C54.582 37.4208 48.3759 43.6268 40.7194 43.6268C33.0635 43.6268 26.8574 37.4208 26.8574 29.7643C26.866 22.1118 33.067 15.9108 40.7194 15.9017Z"
      fill="#6C6D84"
    />
    <path
      d="M85.1536 56.4207L71.2101 48.9964C70.7297 48.7344 70.1481 48.7405 69.6733 49.012L56.9106 56C52.2358 52.5222 46.6386 50.7107 40.6869 50.7107C33.2782 50.7269 26.4036 53.6064 21.308 58.8471C16.1477 64.1364 13.3168 71.367 13.3334 79.2121C13.336 80.1047 14.0586 80.8274 14.9507 80.8299L59.9515 80.749C62.0669 83.3756 64.7866 85.4511 67.8775 86.7988L69.7542 87.6236C69.958 87.7147 70.179 87.7587 70.4015 87.7531C70.623 87.749 70.8425 87.7056 71.0483 87.6236L73.1672 86.7017C80.9527 83.4353 86.0164 75.8148 86.0108 67.3714V57.86C86.0113 57.2592 85.6821 56.7064 85.1536 56.4207ZM16.617 77.5787C16.9564 71.2214 19.4313 65.4148 23.6373 61.0955C28.1174 56.4854 34.1834 53.9458 40.7026 53.9458H40.7511C46.1056 53.9458 51.1202 55.6283 55.2772 58.8147V67.5656C55.2797 71.0398 56.1465 74.4584 57.8002 77.5134L16.617 77.5787ZM82.7758 67.3714C82.7788 74.5201 78.4853 80.97 71.8893 83.7256H71.8731L70.4015 84.3562L69.1716 83.8222C62.7025 80.9958 58.5193 74.6096 58.5122 67.5499V58.7986L70.4657 52.2476L82.7758 58.8147V67.3714Z"
      fill="#040325"
    />
    <path
      d="M66.0339 66.5151C65.4533 65.8364 64.4323 65.757 63.7531 66.3376C63.0745 66.9181 62.9951 67.9392 63.5756 68.6178L67.2471 72.9042C67.5556 73.2628 68.0041 73.4691 68.4765 73.4706C68.8472 73.4737 69.2072 73.3483 69.4955 73.1146L78.0364 66.1757C78.7288 65.6083 78.8299 64.5873 78.2625 63.8945C77.6956 63.2022 76.6746 63.101 75.9822 63.6684L68.6707 69.6212L66.0339 66.5151Z"
      fill="#040325"
    />
    <circle
      cx="40.6667"
      cy="29.3333"
      r="11.3333"
      fill="#FFD9C3"
    />
  </svg>
</template>
